<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-22 23:36:01
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/milkplan/components/PlanWeek/index.vue
-->
<template>
  <!-- 订单详情地址信息 -->
  <div class="address_con">
    <div class="filter_blur"></div>
    <div class="con_item text_center">
      <div class="item_font font20 line_height_22 colo087">
        <div>{{ getDistributionPlan.totalPeriods }}</div>
        <div class="font10 line_height_14 colo0 con_bot">配送周期</div>
      </div>
      <div class="line"></div>
    </div>
    <div class="con_item text_center">
      <div class="item_font font20 line_height_22 colo0 text_center">
        <div>1周1送</div>
        <div class="font10 line_height_14 colo0 con_bot">配送周期</div>
      </div>
      <div class="line"></div>
    </div>
    <div class="con_item text_center">
      <div class="item_font font20 line_height_22 colo0 text_center">
        <div>{{ getDistributionPlan.periodNum }}件</div>
        <div class="font10 line_height_14 colo0 con_bot">每期配送件数</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    getDistributionPlan() {
      return this.$store.getters.getDistributionPlan;
    }
  }
};
</script>

<style lang="less" scoped>
.address_con {
  background: rgba(255, 255, 255, 0.6);
  box-shadow: 0px 3px 3px 0px rgba(193, 200, 207, 0.2);
  border-radius: 8px;
  position: relative;
  display: flex;
  justify-content: space-between;
  .filter_blur {
    background: rgba(255, 255, 255, 0.7);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    filter: blur(10px);
    z-index: -1;
  }
  .con_item {
    padding: 13px 0 15px;
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    .line {
      background: #000000;
      border-radius: 1px;
      opacity: 0.55;
      width: 1px;
      height: 15px;
      margin-left: 35px;
    }
  }
  .con_bot {
    margin-top: 5px;
  }
}
</style>
